import { inject } from "@angular/core";
import { CanActivateFn, NavigationEnd, Router } from "@angular/router";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";
import { AuthService } from "@app/shared/auth/services/auth.service";
import { ToastService } from "@kernel/tools/message/service/toast.service";
import { filter, first } from "rxjs";

/**
 * Sends a view-own user who has no company email (Email Aziendale) back to home.
 *
 * Their commissions are read from the CRM by that email, so without it there is nothing they may see. View-all users
 * pass, because they can still pick another seller. Runs after `AuthGuard`, which has already checked that the user
 * holds one of the two permissions. Guards run before any resolver, so the message is shown once the navigation home has
 * finished and the root translations, which hold its key, are loaded.
 */
export const kpiCommissionAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const canViewAll = !!authService.getUser()?.can(PERMISSION_CONSTANTS.KPI_COMMISSION.VIEW);
  const companyEmail = authService.getPlainUser()?.accessManagementCredentials?.userAuthenticationEmail?.trim();

  if (canViewAll || companyEmail) return true;

  const toastService = inject(ToastService);
  const router = inject(Router);
  router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      first()
    )
    .subscribe(() => toastService.error("KPI_COMMISSION.NO_ACCESS_TO_DATA", "ERRORS.SUMMARY"));
  return router.createUrlTree(["/"]);
};
